import { render } from "./ComputeOfferingSelection.vue?vue&type=template&id=ae852bfc&scoped=true"
import script from "./ComputeOfferingSelection.vue?vue&type=script&lang=js"
export * from "./ComputeOfferingSelection.vue?vue&type=script&lang=js"

import "./ComputeOfferingSelection.vue?vue&type=style&index=0&id=ae852bfc&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae852bfc"]])

export default __exports__